export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand-mark" aria-label="SenoSkripsi by Antaseno">
      <svg viewBox="0 0 48 48" aria-hidden="true">
        <path d="M14 6h19l7 7v27H14z" />
        <path d="M33 6v9h9M9 11v31h24M19 19h14M19 26h14M19 33h9" />
        <path className="brand-thread" d="M9 11h8v8H9" />
      </svg>
      {!compact ? (
        <span>
          <strong>SenoSkripsi</strong>
          <small>by Antaseno</small>
        </span>
      ) : null}
    </div>
  );
}
